module.exports = __webpack_public_path__ + "51a8c72a0f291a29cd88089d8d989217.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/sutter_health_2_2023_chart.png
// module id = 1738
// module chunks = 0